import {observer, Popover2, React} from '@api'
import {Icon} from '@blueprintjs/core'
import {Image} from '@material-ui/icons'
import {ToolButton, useWhiteboardStore} from '@modules/whiteboard'
import {whiteboardIcons} from '@modules/whiteboard/icons'
import {TDShapeType} from '@modules/whiteboard/shapes/types'
import {ArrowTopRightIcon, Pencil1Icon, Pencil2Icon, TextIcon} from '@radix-ui/react-icons'
import {Panel} from '~components/Panel'
import {Tooltip} from '../Tooltip'
import * as css from './ShapesMenu.css'

type ShapeShape = 'rectangle' | 'ellipse' | 'line'
const shapeShapes: ShapeShape[] = ['rectangle', 'ellipse', 'line']

export const shapeIcons = {
  rectangle: whiteboardIcons.rect,
  ellipse: whiteboardIcons.ellipse,
  line: whiteboardIcons.line,
  frame: <Icon icon='grid'/>,
  arrow: <ArrowTopRightIcon/>,
  text: <TextIcon/>,
  sticky: <Pencil2Icon/>,
  image: <Image />,
  draw: <Pencil1Icon/>,
  catalogItem: <Icon icon='mugshot' />,
  highlighter: <Icon icon='highlight' />
}

export const ShapesMenu = observer(function ShapesMenu() {
  const {tools: {selectTool, toggleToolLock}, appState: {activeTool, isToolLocked}} = useWhiteboardStore()

  const [lastActiveTool, setLastActiveTool] = React.useState<ShapeShape>('rectangle')

  React.useEffect(() => {
    if (shapeShapes.includes(activeTool as ShapeShape) && lastActiveTool !== activeTool) {
      setLastActiveTool(activeTool as ShapeShape)
    }
  }, [activeTool])

  const selectShapeTool = React.useCallback(() => {
    selectTool(lastActiveTool)
  }, [activeTool])

  const handleDoubleClick = React.useCallback(() => {
    toggleToolLock()
  }, [])

  const isActive = shapeShapes.includes(activeTool as ShapeShape)

  return (
    <Popover2
      interactionKind='click'
      position='top'
      popoverClassName={css.popover}
      content={
        <div className={css.content}>
          <Panel side='center'>
            {shapeShapes.map((shape, i) => (
              <Tooltip
                key={shape}
                label={shape[0].toUpperCase() + shape.slice(1)}
                kbd={(4 + i).toString()}
              >
                <div className={css.item}>
                  <ToolButton
                    variant='primary'
                    onClick={() => {
                      selectTool(shape)
                      setLastActiveTool(shape)
                    }}
                  >
                    {shapeIcons[shape]}
                  </ToolButton>
                </div>
              </Tooltip>
            ))}
          </Panel>
        </div>
      }
    >
      <ToolButton
        variant='primary'
        onDoubleClick={handleDoubleClick}
        isToolLocked={isActive && isToolLocked}
        isActive={isActive}
        onClick={() => selectTool(lastActiveTool)}
      >
        {shapeIcons[lastActiveTool]}
      </ToolButton>
    </Popover2>
  )
})



// WEBPACK FOOTER //
// ./src/modules/whiteboard/components/ToolsPanel/ShapesMenu.tsx